import React from 'react';

function Footer() {
  return (
    <div className="container-fluid mt-5">
      <hr style={{ borderColor: "#374151" }} />

      <p
        className="text-center py-3"
        style={{ color: "#9CA3AF", fontSize: "0.9rem" }}
      >
        © 2025 Aryan Arya. Designed and Built with{" "}
        <span style={{ color: "#EF4444" }}>♥</span>
      </p>
    </div>
  );
}

export default Footer;